import { create } from 'zustand';
export const liveopsStore = create()(() => ({
    canClaim: true,
    dayCounter: 1,
    streakCount: 0,
    nextClaimTime: 0,
    lastClaimResult: null,
}));
